"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketProviderController = void 0;
var _logger = require("@ori/logger");
var _components = require("../components");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
const BasketProviderController = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
  logger: _logger2.mainLogger,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
    areaName: `${_constants.APP_NAME}-boundary`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.BasketProvider, {})
    })
  })
});
exports.BasketProviderController = BasketProviderController;